<template>
  <v-app id="app">
    <HomeView v-if="isAdmin" />
    <MainLayout v-else />
  </v-app>
</template>

<script>
import MainLayout from "./layout/MainLayout";
import HomeView from "@/components/admin/HomeView";

export default {
  name: "App",

  created() {
    // console.log(localStorage.getItem('setLanguage'), 9999)
    // if(localStorage.getItem('setLanguage') === 'en')
    //   this.$router.push({name: 'LanguageHomePage', params: { lang: 'en' }})
    // else if (localStorage.getItem('setLanguage') === 'hr')
    //   this.$router.push({name: 'LanguageHomePage'})
    if(this.$route.params.lang === 'en')
      localStorage.setItem('setLanguage', this.$route.params.lang)
    else if(this.$route.params.lang === undefined)
      localStorage.setItem('setLanguage', 'hr')
    // console.log(this.$route.params.lang)
  },

  components: {
    MainLayout,
    HomeView
  },

  computed: {
    isAdmin() {
      return this.$route.path.match("korisnik");
    }
  },

  data: () => ({})
};
</script>

<style lang="scss">
*,
.v-application .display-2,
.v-application .text-h5,
.v-application .text-body-2,
.v-application .text-body-1 {
  font-family: "Montserrat" !important;
}
.v-tabs {
  height: 100%;
}

.tab-items-row >>> .v-window__container,
.tab-items-row >>> .v-window-item {
  height: 100%;
}

ul {
  list-style-type: none;
}

li {
  display: inline;
}

li a {
  text-decoration: none;
  font-weight: 500;
  color: #576078 !important;
}

.middle-list-item {
  padding: 0 50px;
}

@media only screen and (max-width: 960px) {
  .overflow {
    overflow: hidden;
    height: 100vh;
  }

  .dropdown {
    background-color: white;
    min-height: 100vh;
    position: fixed;
    z-index: 100;
    padding-top: 80px;
  }

  ul {
    margin: 60px 24px 40px 0px;
  }

  li {
    display: block;
    font-size: 18px;
  }

  .middle-list-item {
    padding: 40px 0px;
  }

  .dropdown-sumit {
    position: absolute;
    margin: auto;
    bottom: 16px;
    left: 0;
    right: 0;
  }
}
</style>
